/**
 * `setlist` — tracks played, in order. Carries the SACEM royalty-declaration
 * fields (auteur/compositeur/ISRC/ISWC) — the French collecting-society export
 * consumes these (v1 sacem.jsx; a palette command in v2).
 */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const setlist = defineCollection({
  key: "setlist",
  labelKey: "collections.setlist",
  icon: "music",
  sheetTab: "Setlist",
  dedupFields: ["position", "title"],
  sort: [{ field: "position" }],
  split: "gig",
  chatHint:
    "Tracks played in the set, in order. SACEM royalty fields (author/composer/ISRC/ISWC) " +
    "live per track for the declaration export.",
  fields: {
    position: field({
      type: z.number().int().min(1).optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "setlist.position",
      sheet: { column: "#" },
      description: "Play order, 1-based.",
    }),
    title: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "promoter",
      labelKey: "setlist.title",
      sheet: { column: "Title" },
      description: "Track title.",
    }),
    artist: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "setlist.artist",
      sheet: { column: "Artist" },
      description: "Track artist (may differ from the performer for edits/remixes).",
    }),
    duration: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "setlist.duration",
      sheet: { column: "Duration" },
      description: "Approx duration (MM:SS).",
    }),
    auteur: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "setlist.auteur",
      sheet: { column: "Auteur" },
      description: "SACEM: auteur (lyricist) for the declaration.",
    }),
    compositeur: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "setlist.compositeur",
      sheet: { column: "Compositeur" },
      description: "SACEM: compositeur for the declaration.",
    }),
    isrc: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "setlist.isrc",
      sheet: { column: "ISRC" },
      description: "ISRC code when known.",
    }),
    iswc: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "setlist.iswc",
      sheet: { column: "ISWC" },
      description: "ISWC code when known.",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "setlist.notes",
      sheet: { column: "Notes" },
      description: "Edit/remix/b2b notes.",
    }),
  },
});
